// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wi0EE","title":"styles_title__tzkY9","link":"styles_link__StG3C","tagContainer":"styles_tagContainer__MBi3h"};